import { AxiosInstance } from 'axios';
import { ServiceBaseConfig } from './Interfaces/IAccountService';
import {
  GetCompanyInfoResponse,
  IEnquiry,
  ListCompaniesResponse,
  PayloadServiceRequestDocument
} from './Interfaces/IManagemenntService';

export class ManagementService {
  public static async listCompanies(
    api: AxiosInstance,
    typeCompay: string,
    sortBy: string,
    sortDirection: string,
    currentPage: number,
    config: ServiceBaseConfig,
    extraFilters: Record<string, string> = {}
  ): Promise<ListCompaniesResponse> {
    const filterParts = [`type=${typeCompay}`, ...Object.entries(extraFilters)
      .filter(([, value]) => value !== undefined && value !== null && String(value).trim() !== '')
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)];

    const normalizedSortBy = sortBy?.trim() || 'created_at';
    const normalizedSortDirection = sortDirection?.trim() || 'desc';

    // Staging still ignores `created_at` (not in its sortable whitelist). Append `id`
    // with the same direction so page 1 is newest-first until the API fix is deployed.
    const order =
      normalizedSortBy === 'created_at'
        ? `created_at=${normalizedSortDirection},id=${normalizedSortDirection}`
        : `${normalizedSortBy}=${normalizedSortDirection}`;

    const { data } = await api.get(
      `/companies/all?filters=${filterParts.join(',')}&order=${order}&page=${currentPage}`,
      config
    );

    return data;
  }

  public static async getCompanyInfo(
    api: AxiosInstance,
    slug: string | number,
    config: ServiceBaseConfig
  ): Promise<GetCompanyInfoResponse> {
    const { data } = await api.get(`/companies/${slug}/info`, config);
    if (!data) {
      console.error('Company Info not found');
    }
    return data;
  }

  public static async approveCompany(api: AxiosInstance, slug: string | number, config: ServiceBaseConfig): Promise<any> {
    const { data } = await api.post(`/companies/${slug}/approve`, undefined, config);

    return data;
  }

  public static async approveTransferCompany(api: AxiosInstance, slug: string | number, config: ServiceBaseConfig): Promise<any> {
    const { data } = await api.post(`/companies/${slug}/approve`, undefined, config);

    return data;
  }

  public static async getCompanyDocuments(api: AxiosInstance, slug: number, config: ServiceBaseConfig): Promise<any> {
    const { data } = await api.get(`/companies/${slug}/documents`, config);

    return data;
  }

  public static async getDocumentUrl(api: AxiosInstance, payload: any, config: ServiceBaseConfig): Promise<{ links: { link: string }[] }> {
    const { data } = await api.post('/get-files', payload, config);

    return data;
  }

  public static async completeRegister(
    api: AxiosInstance,
    payload: {
      company_id: number;
      registration_number: string;
      // financial_year: string;
      incorporation_date: string;
      name: string;
    },
    config: ServiceBaseConfig
  ): Promise<any> {
    const { data } = await api.put(`/companies/${payload.company_id}`, payload, config);

    return data;
  }

  public static async saveFileCompleteRegister(
    api: AxiosInstance,
    payload: {
      company_id: number;
      certificate: File;
    },
    config: ServiceBaseConfig
  ): Promise<void> {
    const { data } = await api.post(`/companies/${payload.company_id}/certificates`, payload, config);

    return data;
  }

  public static async saveRegisterEnquiry(api: AxiosInstance, payload: IEnquiry, config: ServiceBaseConfig): Promise<any> {
    const { data } = await api.post('/enquiries', payload, config);

    return data;
  }

  public static async saveApprovedOrRejectDocument(
    api: AxiosInstance,
    documentId: string | number,
    payload: { action: string },
    config: ServiceBaseConfig
  ): Promise<any> {
    const { data } = await api.post(`companies/documents/${documentId}/approve-reject`, payload, config);

    return data;
  }

  public static async getEnquirySubjects(api: AxiosInstance, config: ServiceBaseConfig): Promise<any> {
    const { data } = await api.get('/enquiries/subjects?per_page=100', config);

    return data;
  }

  public static async getServicesRequestsCompanies(api: AxiosInstance, config: ServiceBaseConfig): Promise<any> {
    const { data } = await api.get('/companies/services-requests-companies?page=1', config);

    return data;
  }

  public static async saveDocumentServicesRequestsCompany(
    api: AxiosInstance,
    payload: PayloadServiceRequestDocument,
    config: ServiceBaseConfig
  ): Promise<any> {
    const { data } = await api.post('/companies/services-requests/upload-document', payload, config);

    return data;
  }
}
